(function () {
  var KEY = 'toaWishlistProducts.v1';

  function readItems() {
    try {
      var parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter(function (item) { return item && item.id; }) : [];
    } catch (error) {
      return [];
    }
  }

  function writeItems(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (error) {}
  }

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function absoluteUrl(value) {
    value = clean(value);
    if (!value) return '';
    if (value.indexOf('//') === 0) return window.location.protocol + value;
    if (value.indexOf('/') === 0) return value;
    return value;
  }

  function itemFromButton(button) {
    return {
      id: clean(button.getAttribute('data-product-id')),
      variantId: clean(button.getAttribute('data-variant-id')),
      handle: clean(button.getAttribute('data-product-handle')),
      title: clean(button.getAttribute('data-product-title')),
      url: absoluteUrl(button.getAttribute('data-product-url')),
      image: absoluteUrl(button.getAttribute('data-product-image')),
      price: clean(button.getAttribute('data-product-price')),
      available: clean(button.getAttribute('data-product-available')),
      addedAt: new Date().toISOString()
    };
  }

  function hasItem(items, id) {
    return items.some(function (item) { return item.id === id; });
  }

  function toggleItem(item) {
    var items = readItems();
    if (hasItem(items, item.id)) {
      items = items.filter(function (entry) { return entry.id !== item.id; });
    } else {
      items.unshift(item);
    }
    writeItems(items);
    updateAll();
  }

  function updateButtons(items) {
    var buttons = document.querySelectorAll('[data-toa-wishlist-toggle]');
    buttons.forEach(function (button) {
      var id = clean(button.getAttribute('data-product-id'));
      var active = hasItem(items, id);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Aus Wunschliste entfernen' : 'Zur Wunschliste hinzufuegen');
      var text = button.querySelector('.toa-wishlist-card-button__text');
      if (text) text.textContent = active ? 'Gemerkt' : 'Wunschliste';
    });
  }

  function updateHeader(items) {
    var count = items.length;
    document.querySelectorAll('[data-toa-wishlist-count]').forEach(function (node) {
      node.textContent = String(count);
      if (count > 0) node.removeAttribute('hidden');
      else node.setAttribute('hidden', 'hidden');
    });
    document.querySelectorAll('.toa-wishlist-header').forEach(function (node) {
      node.classList.toggle('is-active', count > 0);
      node.setAttribute('aria-label', count > 0 ? 'Wunschliste mit ' + count + ' Produkten' : 'Wunschliste');
    });
  }

  function escapeHtml(value) {
    return clean(value).replace(/[&<>"']/g, function (ch) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
    });
  }

  function renderPage(items) {
    var root = document.querySelector('[data-toa-wishlist-page]');
    if (!root) return;
    var empty = root.querySelector('[data-toa-wishlist-empty]');
    var filled = root.querySelector('[data-toa-wishlist-filled]');
    var grid = root.querySelector('[data-toa-wishlist-grid]');
    var count = root.querySelector('[data-toa-wishlist-page-count]');
    if (count) count.textContent = items.length === 1 ? '1 Produkt gemerkt' : items.length + ' Produkte gemerkt';
    if (!grid || !empty || !filled) return;
    if (!items.length) {
      empty.removeAttribute('hidden');
      filled.setAttribute('hidden', 'hidden');
      grid.innerHTML = '';
      return;
    }
    empty.setAttribute('hidden', 'hidden');
    filled.removeAttribute('hidden');
    grid.innerHTML = items.map(function (item) {
      var img = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '<span aria-hidden="true">?</span>';
      var price = item.price ? '<div class="toa-wishlist-item__price">' + escapeHtml(item.price) + '</div>' : '';
      return '<article class="toa-wishlist-item" data-toa-wishlist-item="' + escapeHtml(item.id) + '">' +
        '<a class="toa-wishlist-item__media" href="' + escapeHtml(item.url || '/collections/all') + '">' + img + '</a>' +
        '<div class="toa-wishlist-item__body">' +
          '<a class="toa-wishlist-item__title" href="' + escapeHtml(item.url || '/collections/all') + '">' + escapeHtml(item.title || 'Produkt') + '</a>' +
          price +
          '<div class="toa-wishlist-item__buttons">' +
            '<a class="toa-wishlist-item__link" href="' + escapeHtml(item.url || '/collections/all') + '">Zum Produkt</a>' +
            '<button type="button" class="toa-wishlist-item__remove" data-toa-wishlist-remove="' + escapeHtml(item.id) + '">Entfernen</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');
  }

  function updateAll() {
    var items = readItems();
    updateButtons(items);
    updateHeader(items);
    renderPage(items);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-toa-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      var item = itemFromButton(toggle);
      if (item.id) toggleItem(item);
      return;
    }
    var remove = event.target.closest && event.target.closest('[data-toa-wishlist-remove]');
    if (remove) {
      var id = clean(remove.getAttribute('data-toa-wishlist-remove'));
      writeItems(readItems().filter(function (item) { return item.id !== id; }));
      updateAll();
      return;
    }
    var clear = event.target.closest && event.target.closest('[data-toa-wishlist-clear]');
    if (clear) {
      writeItems([]);
      updateAll();
    }
  });

  document.addEventListener('DOMContentLoaded', updateAll);
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) updateAll();
  });
  window.toaWishlist = { read: readItems, refresh: updateAll };
  setTimeout(updateAll, 400);
  setTimeout(updateAll, 1400);
})();
